import { useMemo } from "react";

import { getFullName } from "~/common/utils/user";

const useUserFullName = (firstName: string | undefined, lastName: string | undefined) => {
  return useMemo(() => getFullName(firstName, lastName), [firstName, lastName]);
};

export default useUserFullName;
